module.exports = __webpack_public_path__ + "img/logo-m2n.25f3a3e8.svg";